const avtoPathesHead = {
  city: (data, p) => ({
    title: `Мотосалоны ${p.t(data.city)}. Магазины по продаже мотоциклов, скутеров, квадроциклов - АвтоБазар`,
    description: `Мотосалоны ${p.t(data.city)}. Лучшие цены на мототехнику с гарантией от салона ✅ адреса и телефоны мото магазинов ☎️ на сайте АвтоБазар`,
    header: `Мотосалоны ${p.t(data.city)}`,
    title_uk: `Мотосалони ${p.t(data.city)}. Магазини з продажу мотоциклів, скутерів, квадроциклів - Автобазар`,
    description_uk: `Мотосалони ${p.t(data.city)}. Кращі ціни на мототехніку з гарантією від салону ✅ адреси і телефони мото магазинів ☎️ на сайті Автобазар`,
    header_uk: `Мотосалони ${p.t(data.city)}`,
  }),
};

export default avtoPathesHead;



// WEBPACK FOOTER //
// ./src/shared/helpers/seoTextFinder/seoTemplates/avtosalony/mototsikl/templates.js